export const SUPPORTED_LANGS = ["sk", "en", "de"];

export const dict = {
  sk: {
    nav: {
      about: "O nás",
      rooms: "Izby",
      wellness: "Wellness",
      audiences: "Pobyty",
      services: "Služby",
      location: "Lokalita",
      reviews: "Recenzie",
      contact: "Kontakt",
      book: "Overiť dostupnosť",
      admin: "Admin",
      navigate: "Navigácia",
    },
    hero: {
      overline: "Ubytovanie 8 km od Štrbského Plesa s wellness",
      title1: "Pokojné ubytovanie v",
      title2: "Tatranskej Štrbe s wellness",
      subtitle:
        "Len 8 minút od Štrbského Plesa. Penzión ŠTRBA *** — celoročné ubytovanie s privátnym wellness, reštauráciou a bezplatným parkovaním. 30 izieb v srdci Vysokých Tatier.",
      cta: "Overiť dostupnosť",
      ctaWellness: "Rezervovať Wellness",
      ctaSecondary: "Spoznať penzión",
      priceTag: "od 59 €/noc",
      priceTagLabel: "Pobyty",
      stars: "3 hviezdičky",
      parking: "Bezplatné parkovanie",
      kmTag: "8 km od Štrbského Plesa",
      comingSoon: "Online rezervácia izieb bude čoskoro spustená. Pre rezerváciu nás prosím kontaktujte.",
    },
    wellness: {
      overline: "Wellness",
      title: "Privátny wellness. Len pre vás.",
      subtitle:
        "Oddýchnite si v atmosfére sviečok, RGB svetla a jemného tepla. Wellness 8 km od Štrbského Plesa, rezervovaný výhradne pre jedného hosťa v čase vstupu.",
      items: [
        { t: "Infra sauna", d: "40 – 65 °C  •  regenerácia svalov" },
        { t: "Vírivá vaňa", d: "S perličkovým kúpeľom  •  RGB chromoterapia" },
        { t: "Oddychová zóna", d: "Tlmené LED svetlo  •  ticho" },
      ],
      price: "od 30 € / hod",
      note: "Max. 2 osoby  •  nutná rezervácia",
      step: "Krok",
      done: "Dokončené",
      bookingTitle: "Rezervácia Wellness",
      thanks: "Ďakujeme za rezerváciu",
      successMessage: "Vaša rezervácia do wellness bola úspešne prijatá. Potvrdenie sme vám odoslali na email.",
      close: "Zavrieť okno",
      selectDate: "Vyberte dátum",
      selectTime: "Vyberte čas",
      adults: "Počet dospelých",
      children: "Počet detí",
      capacityNote: "Wellness je privátny a má limitovanú kapacitu na maximálne 2 osoby.",
      summary: "Súhrn výberu",
      date: "Dátum",
      time: "Čas",
      capacity: "Kapacita",
      persons: "osoby",
      totalPrice: "Celková cena",
      firstName: "Meno",
      lastName: "Priezvisko",
      email: "E-mail",
      phone: "Telefón",
      finalSummary: "Finálna rekapitulácia",
      guests: "Hostia",
      adultsShort: "dosp.",
      childrenShort: "deti",
      payAtPlace: "Suma k úhrade na mieste",
      back: "Späť",
      continue: "Pokračovať",
      confirm: "Potvrdiť wellness",
      submitting: "Odosielam...",
      error: "Chyba pri rezervácii",
    },
    about: {
      overline: "O penzióne",
      title: "Miesto, kde sa čas spomalí.",
      body: "Usadené v srdci Vysokých Tatier, kde Štrbské pleso dýcha ráno hmlou a lesy v noci stíchnu. Penzión Štrba is a story of hospitality, chutiach domácej kuchyne a tichom luxuse horského útočiska. Priestor navrhnutý s rešpektom k prírode a detailu.",
      stats: [
        { label: "Izieb", value: "30" },
        { label: "km k Štrbskému plesu", value: "8" },
        { label: "Hviezdičkové prostredie", value: "3★" },
        { label: "Celoročná prevádzka", value: "365 dní" },
      ],
    },
    rooms: {
      overline: "Izby",
      title: "Ticho. Svetlo. Výhľad na hory.",
      subtitle:
        "Každá izba je navrhnutá ako osobné útočisko. Prírodné materiály, mäkké tkaniny a technológie, ktoré nerušia. 8 km od Štrbského Plesa.",
      from: "od",
      night: "/ noc",
      guests: "Kapacita",
      book: "Overiť dostupnosť",
    },
    services: {
      overline: "Služby a vybavenie",
      title: "Vybavenie, ktoré premyslí zážitok za vás.",
      detailLabel: "Detail služby",
      detailDefaultDesc: "V našom penzióne dbáme na maximálne pohodlie, čistotu a spokojnosť hostí. Táto služba je plne k dispozícii pre všetkých ubytovaných návštevnických hostí počas celého pobytu u nás v Štrbe.",
      closeBtn: "Zatvoriť",
      items: [
        { t: "Reštaurácia & Pizzeria", d: "Denne 15:00 – 23:00" },
        { t: "Jedáleň", d: "Priestor na stravovanie" },
        { t: "Raňajkový bufet", d: "07:30 – 09:00 v cene" },
        { t: "Wifi zdarma", d: "V celom objekte" },
        { t: "Bezplatné parkovanie", d: "Priamo pri penzióne" },
        { t: "Nefajčiarsky objekt", d: "Čisté a zdravé prostredie" },
        { t: "Lyžiareň", d: "Vyhrievaná a uzamykateľná" },
        { t: "Požičovňa lyží", d: "Zľava pre hostí" },
        { t: "Kuchynky na poschodí", d: "Plne vybavené" },
        { t: "Školiaca miestnosť", d: "Kapacita až 40 osôb" },
        { t: "Detský kútik", d: "Priestor pre najmenších" },
        { t: "Informačný leták", d: "Všetky informácie na jednom mieste" },
        { t: "Privátny Wellness", d: "Dokonalý relax v saune a vírivke" },
        { t: "Rodinné oslavy a spoločenské akcie", d: "Narodeniny, jubileá a krstiny" },
      ],
    },
    location: {
      overline: "Lokalita",
      title: "8 km od Štrbského plesa.",
      subtitle: "Diaľnica 5 minút autom  •  vlak 10 minút pešo  •  autobus 5 minút.",
      summer: "Leto",
      winter: "Zima",
      relax: "Relax",
      summerItems: ["Vysokohorské túry", "160+ km cyklotrás", "Člnkovanie na Plese", "Spišský hrad"],
      winterItems: ["Štrbské Pleso lyžovanie", "Lučivná", "Bežkovanie", "Skialpinizmus"],
      relaxItems: ["Aquacity Poprad", "Tatralandia", "Bešeňová", "Jaskyne"],
      
      navTitle: "Ako sa k nám dostanete?",
      navSubtitle: "NAVIGAČNÉ POKYNY",
      trainCard: {
        title: "Zo železničnej stanice (cca 10 min)",
        steps: [
          "Na konci staničnej budovy sa vydajte po chodníku rovno až k benzínovej pumpe (cca 500m).",
          "Ďalej prejdete po prechode cez hlavnú cestu na druhú stranu.",
          "Pokračujte po chodníku okolo Slovenskej Koliby a ďalej rovno na sever (cca 400m).",
          "Po ľavej strane uvidíte budovu potravín a reštaurácie – vchod do penziónu je hneď za reštauráciou."
        ]
      },
      busCard: {
        title: "Z autobusovej zastávky (cca 5 min)",
        steps: [
          "Po vystúpení z autobusu sa vydajte rovno, smerom na Štrbské Pleso až ku Slovenskej Kolibe (cca 50m).",
          "Pokračujte po chodníku rovno okolo Slovenskej Koliby smerom na sever (cca 400m).",
          "Po ľavej strane uvidíte budovu potravín a reštaurácie.",
          "Vchod do penziónu je hneď za reštauráciou."
        ]
      },
      carEastCard: {
        title: "Autom od Prešova / Popradu (cca 5 min)",
        steps: [
          "Za tunelom Bôrik použite výjazd z dálnice na Štrbu.",
          "Potom pokračujte stále rovno, smerom na Tatranskú Štrbu.",
          "Na najbližšej križovatke v Tatranskej Štrbe pokračujte rovno, smerom na Štrbské Pleso.",
          "Po ľavej strane uvidíte budovu potravín a reštaurácie – vchod do penziónu je hneď za reštauráciou."
        ]
      },
      carWestCard: {
        title: "Autom od Žiliny / Lipt. Mikuláša (cca 5 min)",
        steps: [
          "Na diaľnici použite výjazd na Štrbu.",
          "Potom pokračujte stále rovno, smerom na Tatranskú Štrbu.",
          "Na najbližšej križovatke v Tatranskej Štrbe pokračujte rovno, smerom na Štrbské Pleso.",
          "Po ľavej strane uvidíte budovu potravín a reštaurácie – vchod do penziónu je hneď za reštauráciou."
        ]
      }
    },
    reviews: {
      overline: "Recenzie",
      title: "Čo o nás hovoria hostia 8 km od Štrbského Plesa.",
    },
    contact: {
      overline: "Kontakt",
      title: "Napíšte nám.",
      name: "Meno a priezvisko",
      email: "E-mail",
      phone: "Telefón",
      subject: "Predmet",
      message: "Správa",
      send: "Odoslať správu",
      sent: "Správa bola odoslaná.",
    },
    booking: {
      title: "Rezervácia pobytu",
      subtitle: "Vyplňte nasledujúce údaje a my potvrdíme dostupnosť do 24 hodín.",
      step: "Krok",
      of: "z",
      step1: "Termín & izba",
      step2: "Hostia & extra",
      step3: "Kontakt & potvrdenie",
      checkin: "Príchod",
      checkout: "Odchod",
      chooseDates: "Vyberte termín",
      room: "Typ izby",
      adults: "Dospelí",
      children: "Betové / Deti",
      wellness: "Privátny wellness (30 €/hod)",
      halfBoard: "Polpenzia — večera (10 € / os / noc)",
      firstName: "Meno",
      lastName: "Priezvisko",
      email: "Email",
      phone: "Telefón",
      notes: "Poznámky (voliteľné)",
      next: "Pokračovať",
      back: "Späť",
      confirm: "Odoslať rezerváciu",
      summary: "Zhrnutie",
      nights: "nocí",
      total: "Predpokladaná cena",
      thanks: "Ďakujeme! Vašu rezerváciu sme prijali.",
      thanksBody: "Potvrdenie sme zaslali na váš e-mail. Ozveme sa vám do 24 hodín.",
      close: "Zavrieť",
    },
    admin: {
      login: "Prihlásenie",
      email: "Email",
      password: "Heslo",
      signIn: "Prihlásiť sa",
      dashboard: "Dashboard",
      reservations: "Rezervácie",
      messages: "Správy",
      logout: "Odhlásiť",
      total: "Celkom rezervácií",
      pending: "Čakajúce",
      confirmed: "Potvrdené",
      cancelled: "Zrušené",
      revenue: "Tržba",
      status: "Stav",
      guest: "Hosť",
      dates: "Termín",
      price: "Cena",
      actions: "Akcie",
      markConfirmed: "Potvrdiť",
      markCancelled: "Zrušiť",
      delete: "Vymazať",
    },
    audiences: {
      overline: "Pre koho je penzión",
      title: "Ubytovanie 8 km od Štrbského Plesa, šité na mieru.",
      cards: [
        {
          id: "families",
          tag: "Pre rodiny",
          title: "Bezpečný horský pobyt s deťmi.",
          body: "Detský kútik, izby s prístelkou, deti do 6 rokov zdarma. 8 km od Štrbského Plesa — výlety, člnkovanie a aquaparky na dosah.",
          bullets: ["Deti do 6 rokov zdarma", "Detská postieľka 15 €/noc", "Detský kútik", "Bezpečné parkovisko"],
        },
        {
          id: "groups",
          tag: "Pre skupiny",
          title: "Firmy, školy, teambuildingy.",
          body: "Školiaca miestnosť až pre 40 osôb, salónik, individuálne cenové ponuky pre teambuildingy, lyžiarske kurzy a firemné výjazdy.",
          bullets: ["Školiaca miestnosť 40 osôb", "Coffee break a catering", "Individuálne ceny", "Bezplatné parkovisko"],
        },
        {
          id: "wellness",
          tag: "Wellness pobyt v srdci Tatier",
          title: "Pobyt + sauna + vírivka.",
          body: "Privátny wellness od 30 €/hod, perličkový kúpeľ, infra sauna a chromoterapia. Zľavy na lyžiarske strediská a aquaparky pre hostí.",
          bullets: ["Privátny wellness", "Polpenzia 10 €/os/noc", "Zľavy do aquaparkov", "Min. 2 noci"],
        },
        {
          id: "flyer",
          tag: "Celoročné zážitky",
          title: "Aktívna dovolenka v Tatrách.",
          body: "Stiahnite si nášho sprievodcu s prehľadom najlepších aktivít. V lete turistika a cyklotrasy, v zime dokonalá lyžovačka a bežkovanie len kúsok od penziónu.",
          bullets: ["Informačný leták na stiahnutie", "Tipy na letné aj zimné túry", "Zvýhodnené skipasy", "Mapy cyklotrás v okolí"],
        },
        {
          id: "celebrations",
          tag: "Oslavy a podujatia",
          title: "Oslavy",
          body: "Naplánujte si narodeninové oslavy, jubileá, krstiny či menšie svadby priamo v našom penzióne. Zabezpečíme kompletné menu, ubytovanje a súkromie.",
          bullets: ["Kapacita podujatí do 40 osôb", "Tradičné domáce menu", "Možnosť rezervácie celého objektu", "Individuálny prístup k výzdobe"],
        },
      ],
      cta: "Spýtať sa na pobyt",
    },
    trust: {
      stars: "3 hviezdičky",
      starsSub: "Klasifikovaný penzión",
      km: "8 km",
      kmSub: "od Štrbského Plesa",
      parking: "Zdarma",
      parkingSub: "Parkovanie pre hostí",
      year: "365 dní",
      yearSub: "Celoročná prevádzka",
    },
    footer: {
      tagline: "Ubytovanie 8 km od Štrbského Plesa s wellness. Pokoj detailov.",
      address: "Horská 1130/31, 059 41 Tatranská Štrba",
      rights: "Všetky práva vyhradené.",
    },
  },
  en: {
    nav: {
      about: "About",
      rooms: "Rooms",
      wellness: "Wellness",
      audiences: "Stays",
      services: "Services",
      location: "Location",
      reviews: "Reviews",
      contact: "Contact",
      book: "Check availability",
      admin: "Admin",
      navigate: "Navigation",
    },
    hero: {
      overline: "Accommodation 8 km from Štrbské Pleso with wellness",
      title1: "Quiet of the mountains.",
      title2: "8 km from Štrbské Pleso.",
      subtitle:
        "Just 8 minutes from Štrbské Pleso. Penzión ŠTRBA *** — year-round accommodation with private wellness, restaurant and free parking. 30 rooms in the heart of the High Tatras.",
      cta: "Check availability",
      ctaWellness: "Book Wellness",
      ctaSecondary: "Explore the property",
      priceTag: "from €59 / night",
      priceTagLabel: "Stays",
      stars: "3 stars",
      parking: "Free parking",
      kmTag: "8 km from Štrbské Pleso",
      comingSoon: "Online room booking will be available soon. Please contact us to make a reservation.",
    },
    wellness: {
      overline: "Wellness",
      title: "Private wellness. Just for you.",
      subtitle: "Relax in candlelight, RGB glow and gentle warmth. Our wellness zone is reserved exclusively for a single guest at a time.",
      items: [
        { t: "Infra sauna", d: "40 – 65 °C  •  muscle recovery" },
        { t: "Whirlpool", d: "With bubble bath  •  chromotherapy" },
        { t: "Relax zone", d: "Dim LED light  •  silence" },
      ],
      price: "from €30 / hour",
      note: "Max 2 guests  •  reservation required",
      step: "Step",
      done: "Done",
      bookingTitle: "Wellness Reservation",
      thanks: "Thank you for your reservation",
      successMessage: "Your wellness reservation has been successfully received. A confirmation has been sent to your email.",
      close: "Close window",
      selectDate: "Select date",
      selectTime: "Select time",
      adults: "Number of adults",
      children: "Number of children",
      capacityNote: "Wellness is private and has a limited capacity of maximum 2 people.",
      summary: "Selection summary",
      date: "Date",
      time: "Time",
      capacity: "Capacity",
      persons: "persons",
      totalPrice: "Total price",
      firstName: "First name",
      lastName: "Last name",
      email: "E-mail",
      phone: "Phone",
      finalSummary: "Final summary",
      guests: "Guests",
      adultsShort: "adults",
      childrenShort: "kids",
      payAtPlace: "Amount to be paid on site",
      back: "Back",
      continue: "Continue",
      confirm: "Confirm wellness",
      submitting: "Sending...",
      error: "Error during reservation",
    },
    about: {
      overline: "About",
      title: "Where time slows down.",
      body: "Nestled in the heart of the High Tatras, where Štrbské Pleso breathes morning mist and forests fall silent at night. Penzión Štrba is a story of hospitality, home-cooked flavors and the quiet luxury of a mountain retreat. Space designed with respect for nature and detail.",
      stats: [
        { label: "Rooms", value: "30" },
        { label: "km to Štrbské Pleso", value: "8" },
        { label: "Star environment", value: "3★" },
        { label: "Open all year", value: "365 days" },
      ],
    },
    rooms: {
      overline: "Rooms",
      title: "Silence. Light. Mountain views.",
      subtitle: "Every room is designed as a personal sanctuary. Natural materials, soft fabrics, technology that does not intrude. 8 km from Štrbské Pleso.",
      from: "from",
      night: "/ night",
      guests: "Capacity",
      book: "Check availability",
    },
    services: {
      overline: "Services & Amenities",
      title: "Amenities that think ahead for you.",
      detailLabel: "Service detail",
      detailDefaultDesc: "In our pension, we care about maximum comfort, cleanliness, and guest satisfaction. This service is fully available to all accommodated visitors throughout their stay with us in Štrba.",
      closeBtn: "Close",
      items: [
        { t: "Restaurant & Pizzeria", d: "Daily 3 PM – 11 PM" },
        { t: "Dining room", d: "Space for dining" },
        { t: "Breakfast buffet", d: "07:30 – 09:00 included" },
        { t: "Free WiFi", d: "Throughout the property" },
        { t: "Free parking", d: "Right at the property" },
        { t: "Non-smoking object", d: "Clean and healthy environment" },
        { t: "Ski room", d: "Heated and lockable" },
        { t: "Ski rental", d: "Guest discount" },
        { t: "Kitchenettes", d: "Fully equipped per floor" },
        { t: "Conference room", d: "Capacity up to 40" },
        { t: "Kids corner", d: "Space for the little ones" },
        { t: "Information Brochure", d: "All information in one place" },
        { t: "Private Wellness", d: "Perfect relaxation in sauna and whirlpool" },
        { t: "Family Celebrations & Social Events", d: "Birthdays, anniversaries and baptisms" },
      ],
    },
    location: {
      overline: "Location",
      title: "8 km from Štrbské Pleso.",
      subtitle: "Highway 5 min by car  •  train 10 min on foot  •  bus 5 min.",
      summer: "Summer",
      winter: "Winter",
      relax: "Relax",
      summerItems: ["High-altitude hiking", "160+ km of bike trails", "Boating on the lake", "Spiš Castle"],
      winterItems: ["Štrbské Pleso skiing", "Lučivná", "Cross-country skiing", "Ski touring"],
      relaxItems: ["Aquacity Poprad", "Tatralandia", "Bešeňová", "Caves"],
      navTitle: "How to get to us?",
      navSubtitle: "NAVIGATION DIRECTIONS",
      trainCard: {
        title: "From the railway station (approx. 10 min)",
        steps: [
          "At the end of the station building, head straight along the sidewalk to the gas station (approx. 500m).",
          "Then cross the main road to the other side using the crosswalk.",
          "Continue along the sidewalk past Slovenská Koliba and straight north (approx. 400m).",
          "On the left side, you will see the grocery and restaurant building – the guesthouse entrance is right behind the restaurant."
        ]
      },
      busCard: {
        title: "From the bus stop (approx. 5 min)",
        steps: [
          "After getting off the bus, head straight towards Štrbské Pleso until you reach Slovenská Koliba (approx. 50m).",
          "Continue straight along the sidewalk past Slovenská Koliba heading north (approx. 400m).",
          "On the left side, you will see the grocery and restaurant building.",
          "The entrance to the guesthouse is right behind the restaurant."
        ]
      },
      carEastCard: {
        title: "By car from Prešov / Poprad (approx. 5 min)",
        steps: [
          "After the Bôrik tunnel, take the exit from the highway toward Štrba.",
          "Then continue straight towards Tatranská Štrba.",
          "At the nearest intersection in Tatranská Štrba, continue straight toward Štrbské Pleso.",
          "On the left side, you will see the grocery and restaurant building – the guesthouse entrance is right behind the restaurant."
        ]
      },
      carWestCard: {
        title: "By car from Žilina / Lipt. Mikuláš (approx. 5 min)",
        steps: [
          "On the highway, take the exit toward Štrba.",
          "Then continue straight towards Tatranská Štrba.",
          "At the nearest intersection in Tatranská Štrba, continue straight toward Štrbské Pleso.",
          "On the left side, you will see the grocery and restaurant building – the guesthouse entrance is right behind the restaurant."
        ]
      }
    },
    reviews: { overline: "Reviews", title: "What our guests say 8 km from Štrbské Pleso." },
    contact: { overline: "Contact", title: "Write to us.", name: "Full name", email: "E-mail", phone: "Phone", subject: "Subject", message: "Message", send: "Send message", sent: "Your message has been sent." },
    booking: {
      title: "Book your stay",
      subtitle: "Fill in the details below — we will confirm availability within 24 hours.",
      step: "Step",
      of: "of",
      step1: "Dates & room",
      step2: "Guests & extras",
      step3: "Contact & confirm",
      checkin: "Check-in",
      checkout: "Check-out",
      chooseDates: "Choose dates",
      room: "Room type",
      adults: "Adults",
      children: "Children",
      wellness: "Private wellness (€30/hour)",
      halfBoard: "Half board — dinner (€10 / person / night)",
      firstName: "First name",
      lastName: "Last name",
      email: "Email",
      phone: "Phone",
      notes: "Notes (optional)",
      next: "Continue",
      back: "Back",
      confirm: "Submit reservation",
      summary: "Summary",
      nights: "nights",
      total: "Estimated total",
      thanks: "Thank you! Your reservation has been received.",
      thanksBody: "A confirmation has been sent to your email. We will be in touch within 24 hours.",
      close: "Close",
    },
    admin: {
      login: "Sign in",
      email: "Email",
      password: "Password",
      signIn: "Sign in",
      dashboard: "Dashboard",
      reservations: "Reservations",
      messages: "Messages",
      logout: "Log out",
      total: "Total reservations",
      pending: "Pending",
      confirmed: "Confirmed",
      cancelled: "Cancelled",
      revenue: "Revenue",
      status: "Status",
      guest: "Guest",
      dates: "Dates",
      price: "Price",
      actions: "Actions",
      markConfirmed: "Confirm",
      markCancelled: "Cancel",
      delete: "Delete",
    },
    audiences: {
      overline: "Who it's for",
      title: "Accommodation 8 km from Štrbské Pleso, tailored to you.",
      cards: [
        {
          id: "families",
          tag: "For families",
          title: "A safe mountain stay with kids.",
          body: "Kids corner, rooms with extra beds, children under 6 stay free. 8 km from Štrbské Pleso — trips, boating and aquaparks within reach.",
          bullets: ["Children under 6 free", "Baby cot €15/night", "Kids corner", "Safe parking"],
        },
        {
          id: "groups",
          tag: "For groups",
          title: "Companies, schools, teambuildings.",
          body: "Conference room for up to 40 people, lounge, custom rates for teambuildings, ski courses and corporate getaways.",
          bullets: ["Conference room for 40", "Coffee break & catering", "Custom group rates", "Free parking"],
        },
        {
          id: "wellness",
          tag: "Wellness stay in the heart of the Tatras",
          title: "Stay + sauna + whirlpool.",
          body: "Private wellness from €30/hour, bubble bath, infra sauna and chromotherapy. Discounts on ski resorts and aquaparks for guests.",
          bullets: ["Private wellness", "Half board €10/p/night", "Aquapark discounts", "Min. 2 nights"],
        },
        {
          id: "flyer",
          tag: "Year-round experiences",
          title: "Active vacation in the Tatras.",
          body: "Download our flyer guide with an overview of the best activities. Hiking and cycling trails in summer, perfect skiing and cross-country trails in winter.",
          bullets: ["Flyer guide available for download", "Tips for summer & winter hikes", "Discounted ski passes", "Local cycling maps"],
        },
        {
          id: "celebrations",
          tag: "Celebrations & Events",
          title: "Unforgettable family gatherings.",
          body: "Plan your birthday celebrations, anniversaries, baptisms, or small weddings right at our guesthouse. We provide a full menu, accommodation, and absolute privacy.",
          bullets: ["Event capacity up to 40 people", "Traditional home-cooked menu", "Option to book the entire property", "Individual approach to decorations"],
        },
      ],
      cta: "Ask about a stay",
    },
    trust: {
      stars: "3 stars",
      starsSub: "Classified pension",
      km: "8 km",
      kmSub: "from Štrbské Pleso",
      parking: "Free",
      parkingSub: "Parking for guests",
      year: "365 days",
      yearSub: "Open all year",
    },
    footer: { 
      tagline: "Accommodation 8 km from Štrbské Pleso with wellness. Peace of detail.", 
      address: "Horská 1130/31, 059 41 Tatranská Štrba", 
      rights: "All rights reserved." 
    },
  },
  de: {
    nav: {
      about: "Über uns",
      rooms: "Zimmer",
      wellness: "Wellness",
      audiences: "Aufenthalte",
      services: "Service",
      location: "Lage",
      reviews: "Bewertungen",
      contact: "Kontakt",
      book: "Verfügbarkeit prüfen",
      admin: "Admin",
      navigate: "Navigation",
    },
    hero: {
      overline: "Unterkunft 8 km vom Štrbské Pleso mit Wellness",
      title1: "Ruhige Unterkunft in",
      title2: "Tatranská Štrba mit Wellness",
      subtitle:
        "Nur 8 Minuten von Štrbské Pleso entfernt. Penzión ŠTRBA *** — ganzjährige Unterkunft mit privatem Wellness, Restaurant und kostenlosem Parken. 30 Zimmer im Herzen der Hohen Tatra.",
      cta: "Verfügbarkeit prüfen",
      ctaWellness: "Wellness reservieren",
      ctaSecondary: "Mehr entdecken",
      priceTag: "ab 59 € / Nacht",
      priceTagLabel: "Aufenthalte",
      stars: "3 Sterne",
      parking: "Kostenloses Parken",
      kmTag: "8 km vom Štrbské Pleso",
      comingSoon: "Die Online-Zimmerreservierung wird in Kürze verfügbar sein. Bitte kontaktieren Sie uns für eine Reservierung.",
    },
    wellness: {
      overline: "Wellness",
      title: "Privates Wellness. Nur für Sie.",
      subtitle: "Entspannen Sie bei Kerzenschein, RGB-Licht und sanfter Wärme. Unsere Wellness-Zone ist exklusiv für einen Gast pro Termin reserviert, 8 km vom Štrbské Pleso.",
      items: [
        { t: "Infrarot-Sauna", d: "40 – 65 °C  •  Muskelregeneration" },
        { t: "Whirlpool", d: "Mit Perlbad  •  Farbtherapie" },
        { t: "Ruhezone", d: "Gedämpftes LED  •  Stille" },
      ],
      price: "ab 30 € / Stunde",
      note: "Max 2 Gäste  •  Reservierung erforderlich",
      step: "Schritt",
      done: "Fertig",
      bookingTitle: "Wellness-Reservierung",
      thanks: "Vielen Dank für Ihre Reservierung",
      successMessage: "Ihre Wellness-Reservierung wurde erfolgreich empfangen. Eine Bestätigung wurde an Ihre E-Mail gesendet.",
      close: "Schließen",
      selectDate: "Datum wählen",
      selectTime: "Zeit wählen",
      adults: "Anzahl der Erwachsenen",
      children: "Anzahl der Kinder",
      capacityNote: "Wellness ist privat und hat eine begrenzte Kapazität von maximal 2 Personen.",
      summary: "Zusammenfassung",
      date: "Datum",
      time: "Zeit",
      capacity: "Kapazität",
      persons: "Personen",
      totalPrice: "Gesamtpreis",
      firstName: "Vorname",
      lastName: "Nachname",
      email: "E-Mail",
      phone: "Telefon",
      finalSummary: "Abschlussübersicht",
      guests: "Gäste",
      adultsShort: "Erw.",
      childrenShort: "Kind.",
      payAtPlace: "Vor Ort zu zahlender Betrag",
      back: "Zurück",
      continue: "Weiter",
      confirm: "Wellness bestätigen",
      submitting: "Wird gesendet...",
      error: "Fehler bei der Reservierung",
    },
    about: {
      overline: "Über uns",
      title: "Hier verlangsamt sich die Zeit.",
      body: "Im Herzen der Hohen Tatra, wo das Štrbské Pleso morgens Nebel atmet und Wälder nachts verstummen. Penzión Štrba ist eine Geschichte von Gastfreundschaft, heimischen Aromen und dem leisen Luxus eines Bergrückzugs. Ein Raum, der mit Respekt vor der Natur und dem Detail gestaltet wurde.",
      stats: [
        { label: "Zimmer", value: "30" },
        { label: "km zum Pleso", value: "8" },
        { label: "Sterne-Ambiente", value: "3★" },
        { label: "Ganzjährig", value: "365 Tage" },
      ],
    },
    rooms: {
      overline: "Zimmer",
      title: "Stille. Licht. Bergblick.",
      subtitle: "Jedes Zimmer als persönlicher Rückzugsort gestaltet. Natürliche Materialien, weiche Stoffe, dezente Technik. 8 km vom Štrbské Pleso.",
      from: "ab",
      night: "/ Nacht",
      guests: "Kapazität",
      book: "Verfügbarkeit prüfen",
    },
    services: {
      overline: "Service & Ausstattung",
      title: "Ausstattung, die für Sie mitdenkt.",
      detailLabel: "Service-Details",
      detailDefaultDesc: "In unserer Pension legen wir großen Wert auf maximalen Komfort, Sauberkeit und die Zufriedenheit unserer Gäste. Dieser Service steht allen übernachtenden Gästen während ihres gesamten Aufenthalts in Štrba uneingeschränkt zur Verfügung.",
      closeBtn: "Schließen",
      items: [
        { t: "Restaurant & Pizzeria", d: "Täglich 15:00 – 23:00" },
        { t: "Speisesaal", d: "Platz zum Essen" },
        { t: "Frühstücksbuffet", d: "07:30 – 09:00 inklusive" },
        { t: "WLAN kostenlos", d: "Im gesamten Objekt" },
        { t: "Kostenloses Parken", d: "Direkt am Haus" },
        { t: "Nichtraucherobjekt", d: "Saubere und gesunde Umgebung" },
        { t: "Skiraum", d: "Beheizt und abschließbar" },
        { t: "Skiverleih", d: "Gäste-Rabatt" },
        { t: "Küchen pro Etage", d: "Vollausgestattet" },
        { t: "Seminarraum", d: "Bis zu 40 Personen" },
        { t: "Kinderecke", d: "Platz für die Kleinsten" },
        { t: "Informationsbroschüre", d: "Alle Informationen an einem Ort" },
        { t: "Privater Wellnessbereich", d: "Perfekte Entspannung in Sauna und Whirlpool" },
        { t: "Familienfeiern & gesellschaftliche Veranstaltungen", d: "Geburtstage, Jubiläen und Taufen" },
      ],
    },
    location: {
      overline: "Lage",
      title: "8 km vom Štrbské Pleso.",
      subtitle: "Autobahn 5 Min mit Auto  •  Bahn 10 Min zu Fuß  •  Bus 5 Min.",
      summer: "Sommer",
      winter: "Winter",
      relax: "Relax",
      summerItems: ["Hochgebirgswandern", "160+ km Radwege", "Bootfahren am See", "Burg Zips"],
      winterItems: ["Skifahren in Štrbské Pleso", "Lučivná", "Langlauf", "Skitouren"],
      relaxItems: ["Aquacity Poprad", "Tatralandia", "Bešeňová", "Höhlen"],
      navTitle: "Wie Sie zu uns kommen?",
      navSubtitle: "WEGBESCHREIBUNG",
      trainCard: {
        title: "Vom Bahnhof (ca. 10 Min.)",
        steps: [
          "Gehen Sie am Ende des Bahnhofsgebäudes geradeaus auf dem Gehweg bis zur Tankstelle (ca. 500m).",
          "Überqueren Sie anschließend die Hauptstraße über den Fußgängerüberweg auf die andere Seite.",
          "Gehen Sie weiter auf dem Gehweg an der Slovenská Koliba vorbei und geradeaus nach Norden (ca. 400m).",
          "Auf der linken Seite sehen Sie das Gebäude mit Lebensmittelgeschäft und Restaurant – der Hoteleingang befindet sich direkt hinter dem Restaurant."
        ]
      },
      busCard: {
        title: "Von der Bushaltestelle (ca. 5 Min.)",
        steps: [
          "Gehen Sie nach dem Aussteigen aus dem Bus geradeaus in Richtung Štrbské Pleso bis zur Slovenská Koliba (ca. 50m).",
          "Folgen Sie dem Gehweg geradeaus an der Slovenská Koliba vorbei nach Norden (ca. 400m).",
          "Auf der linken Seite sehen Sie das Gebäude des Lebensmittelgeschäfts und Restaurants.",
          "Der Eingang zur Pension befindet sich direkt hinter dem Restaurant."
        ]
      },
      carEastCard: {
        title: "Mit dem Auto von Prešov / Poprad (ca. 5 Min.)",
        steps: [
          "Nehmen Sie nach dem Bôrik-Tunnel die Autobahnausfahrt nach Štrba.",
          "Fahren Sie anschließend geradeaus weiter in Richtung Tatranská Štrba.",
          "An der nächsten Kreuzung in Tatranská Štrba fahren Sie geradeaus weiter in Richtung Štrbské Pleso.",
          "Auf der linken Seite sehen Sie das Gebäude mit Lebensmittelgeschäft und Restaurant – der Hoteleingang befindet sich direkt hinter dem Restaurant."
        ]
      },
      carWestCard: {
        title: "Mit dem Auto von Žilina / Lipt. Mikuláš (ca. 5 Min.)",
        steps: [
          "Nehmen Sie auf der Autobahn die Ausfahrt nach Štrba.",
          "Fahren Sie anschließend geradeaus weiter in Richtung Tatranská Štrba.",
          "An der nächsten Kreuzung in Tatranská Štrba fahren Sie geradeaus weiter in Richtung Štrbské Pleso.",
          "Auf der linken Seite sehen Sie das Gebäude mit Lebensmittelgeschäft und Restaurant – der Hoteleingang befindet sich direkt hinter dem Restaurant."
        ]
      }
    },
    reviews: { overline: "Bewertungen", title: "Was unsere Gäste sagen – 8 km vom Štrbské Pleso." },
    contact: { overline: "Kontakt", title: "Schreiben Sie uns.", name: "Vor- und Nachname", email: "E-Mail", phone: "Telefon", subject: "Betreff", message: "Nachricht", send: "Nachricht senden", sent: "Ihre Nachricht wurde gesendet." },
    booking: {
      title: "Aufenthalt reservieren",
      subtitle: "Füllen Sie die Angaben aus — wir bestätigen die Verfügbarkeit innerhalb von 24 Stunden.",
      step: "Schritt",
      of: "von",
      step1: "Termin & Zimmer",
      step2: "Gäste & Extras",
      step3: "Kontakt & Bestätigung",
      checkin: "Anreise",
      checkout: "Abreise",
      chooseDates: "Termin wählen",
      room: "Zimmertyp",
      adults: "Erwachsene",
      children: "Kinder",
      wellness: "Privates Wellness (30 €/Std)",
      halfBoard: "Halbpension — Abendessen (10 € / Pers. / Nacht)",
      firstName: "Vorname",
      lastName: "Nachname",
      email: "E-Mail",
      phone: "Telefon",
      notes: "Anmerkungen (optional)",
      next: "Weiter",
      back: "Zurück",
      confirm: "Reservierung senden",
      summary: "Zusammenfassung",
      nights: "Nächte",
      total: "Geschätzter Gesamtpreis",
      thanks: "Danke! Ihre Reservierung ist eingegangen.",
      thanksBody: "Eine Bestätigung wurde an Ihre E-Mail gesendet. Wir melden uns innerhalb von 24 Stunden.",
      close: "Schließen",
    },
    admin: {
      login: "Anmelden",
      email: "E-Mail",
      password: "Passwort",
      signIn: "Anmelden",
      dashboard: "Dashboard",
      reservations: "Reservierungen",
      messages: "Nachrichten",
      logout: "Abmelden",
      total: "Reservierungen gesamt",
      pending: "Offen",
      confirmed: "Bestätigt",
      cancelled: "Storniert",
      revenue: "Umsatz",
      status: "Status",
      guest: "Gast",
      dates: "Zeitraum",
      price: "Preis",
      actions: "Aktionen",
      markConfirmed: "Bestätigen",
      markCancelled: "Stornieren",
      delete: "Löschen",
    },
    audiences: {
      overline: "Für wen",
      title: "Unterkunft 8 km vom Štrbské Pleso, maßgeschneidert.",
      cards: [
        {
          id: "families",
          tag: "Für Familien",
          title: "Sicherer Bergaufenthalt mit Kindern.",
          body: "Kinderecke, Zimmer mit Zustellbett, Kinder bis 6 Jahre kostenlos. 8 km vom Štrbské Pleso — Ausflüge, Bootfahren und Aquaparks.",
          bullets: ["Kinder bis 6 J. kostenlos", "Babybett 15 €/Nacht", "Kinderecke", "Sicheres Parken"],
        },
        {
          id: "groups",
          tag: "Für Gruppen",
          title: "Firmen, Schulen, Teambuildings.",
          body: "Seminarraum für bis zu 40 Personen, Lounge, maßgeschneiderte Preise für Teambuildings, Skikurse und Firmenausflüge.",
          bullets: ["Seminarraum 40 Pers.", "Coffee Break & Catering", "Gruppen-tarife", "Kostenloses Parken"],
        },
        {
          id: "wellness",
          tag: "Wellness-Aufenthalt im Herzen der Tatra",
          title: "Aufenthalt + Sauna + Whirlpool.",
          body: "Privates Wellness ab 30 €/Std, Perlbad, Infra-Sauna und Farbtherapie. Rabatte für Skigebiete und Aquaparks für Gäste.",
          bullets: ["Privates Wellness", "Halbpension 10 €/P./Nacht", "Aquapark-Rabatte", "Min. 2 Nächte"],
        },
        {
          id: "flyer",
          tag: "Ganzjährige Erlebnisse",
          title: "Aktiver Urlaub in der Tatra.",
          body: "Laden Sie unseren Infobrief mit einer Übersicht der besten Aktivitäten herunter. Wandern und Radwege im Sommer, perfektes Skifahren und Langlaufen im Winter.",
          bullets: ["Infobrief zum Download", "Tipps für Sommer- & Wintertouren", "Ermäßigte Skipässe", "Radkarten der Umgebung"],
        },
        {
          id: "celebrations",
          tag: "Feiern und Veranstaltungen",
          title: "Unvergessliche Familientreffen.",
          body: "Planen Sie Ihre Geburtstagsfeiern, Jubiläen, Taufen oder kleine Hochzeiten direkt in unserer Pension. Wir bieten ein komplettes Menü, Unterkunft und absolute Privatsphäre.",
          bullets: ["Veranstaltungskapazität bis 40 Personen", "Traditionelles hausgemachtes Menu", "Option zur Buchung des gesamten Objekts", "Individuelle Dekorationen"],
        },
      ],
      cta: "Aufenthalt anfragen",
    },
    trust: {
      stars: "3 Sterne",
      starsSub: "Klassifizierte Pension",
      km: "8 km",
      kmSub: "vom Štrbské Pleso",
      parking: "Gratis",
      parkingSub: "Parken für Gäste",
      year: "365 Tage",
      yearSub: "Ganzjährig geöffnet",
    },
    footer: { 
      tagline: "Unterkunft 8 km vom Štrbské Pleso mit wellness. Ruhe im Detail.", 
      address: "Horská 1130/31, 059 41 Tatranská Štrba", 
      rights: "Alle Rechte vorbehalten." 
    },
  },
};